import config from 'constants/config'
import { LE_AGENT_HUB } from 'constants/brands'
import useQueryParams from 'hooks/useQueryParams'

export default function useIsLoginV2Enabled(): boolean {
  const query = useQueryParams()
  return config.BRAND === LE_AGENT_HUB && query.get('login-v2') === 'true'
}
